import TextArea from "antd/es/input/TextArea"
import MyInput from "../../../components/ui/MyInput"
import { Dropdown } from "primereact/dropdown"
import { useState } from "react"
import UploadImgPublish from "../../../components/ui/UploadImgPublish"
import Toggle from "../../ThemeScreen/DnDNew/components/DnDItems/DnDSidebarItems/Inputs/Toggle"
import { useSelector } from "react-redux"
import { useDispatch } from "react-redux"
import { Checkbox } from "@nextui-org/react"
import FirebaseIntegrationsItem from "../Integrations/FirebaseIntegrationsItem"
import CreateAction from "../../../components/operational/createAction"
import systemSlice from "../../../redux/systemSlice"
import { translate } from "../../../utils/language"

const Store = ({ storeFormButton, data, setData, onSave }) => {
    const [isOpen, setIsOpen] = useState(false)
    const dispatch = useDispatch()
    const [storeData, setStoreData] = useState({
        APN_key: "",
        appleTeamId: "",
        isCheckedGoogleCloud: false,
        isCheckedGooglePlay: false,
        isCheckedAppleDeveloper: false,
        apn: null,
        apn_url: "",
        iosBundleId: "",
        androidBundleId: ""
    })

    const uploadClientData = async (key, fileData) => {
        if (!fileData) return
        const formData = new FormData();
        formData.append(key, fileData);  // Append the file to FormData

        const response = await CreateAction({
            method: 'post',
            path: `/uploadPrivateFile`,
            showPreLoader: true,
            isFileUploading: false,
            data: formData
        });
        if (response.error) return;
        updateStoreData(key, fileData)

        updateStoreData("apn_url", response?.result?.resultData)
        console.log(response?.result?.resultData)
    };

    const updateStoreData = (key, value) => {
        setStoreData((state) => ({ ...state, [key]: value }))
    }



    return (
        <form className="flex flex-col gap-[20px] p-[20px] "
            onSubmit={(e) => {
                e.preventDefault()
                e.stopPropagation()
                const { apn, apn_url } = storeData
                if ((!apn || !apn_url) && isOpen) {
                    dispatch(systemSlice.actions.setToastError({ detail: translate("missingApn") }))
                    return
                }

                setData(state => ({ ...state, ...storeData }))
                setTimeout(() => {
                    onSave({ ...data, ...storeData })

                })
            }}
        >

            <div className="flex flex-col gap-[20px] flex-wrap">
                <div className="flex flex-row w-full gap-[40px]">

                    <div className=" flex flex-col gap-[10px] w-full">

                        <div>Uygulama Yayınlama Ayarları</div>
                        <Toggle value={isOpen} setItem={() => { setIsOpen(state => !state) }} targetKey={"uploadAppOnCustomStore"} />
                        <div className="flex flex-row gap-[20px] flex-wrap">
                            {isOpen ?
                                <>
                                    <div className="w-[1090px] mx-auto">

                                        <FirebaseIntegrationsItem icon={<img src="https://mobligo-bucket.s3.eu-central-1.amazonaws.com/ios%2B-removebg-preview.png" width={45} height={45} alt="APN logo" />} firebaseData={storeData} onFileUpload={uploadClientData} onUploadName={"apn"} acceptedTypes={[".p8"]} header={"Apple Push Notification"} description={"APN .p8 dosyası"} />
                                    </div>
                                    <div className="flex flex-col gap-[20px] justify-center mx-auto">

                                        <div className="w-[1050px] flex flex-row justify-between">
                                            <div className="flex flex-col w-[500px]">

                                                <MyInput isRequired value={storeData.APN_key} onChange={(e) => (updateStoreData("APN_key", e))} className="" maxLength={100} isLengthActive={true} label={"APN Key Numarası"} placeholder="APN key numarası giriniz." classes={"w-[500px]"} />
                                            </div>
                                            <div className="flex flex-col w-[500px]">

                                                <MyInput isRequired value={storeData.appleTeamId} onChange={(e) => (updateStoreData("appleTeamId", e))} className="" maxLength={100} isLengthActive={true} label={"Apple Developer Takım Id'si"} placeholder="Apple Developer Takım Id'si giriniz." classes={"w-[500px]"} />
                                            </div>

                                        </div>

                                        <div className="w-[1050px] flex flex-row justify-between">
                                            <div className="flex flex-col w-[500px]">

                                                <MyInput isRequired value={storeData.iosBundleId} onChange={(e) => (updateStoreData("iosBundleId", e))} className="" maxLength={100} isLengthActive={true} label={"iOS bundle id"} placeholder="iOS bundle id" classes={"w-[500px]"} />
                                            </div>
                                            <div className="flex flex-col w-[500px]">

                                                <MyInput isRequired value={storeData.androidBundleId} onChange={(e) => (updateStoreData("androidBundleId", e))} className="" maxLength={100} isLengthActive={true} label={"Android bundle id"} placeholder="Android bundle id" classes={"w-[500px]"} />
                                            </div>

                                        </div>

                                        <div className="w-[1050px] flex flex-col justify-between gap-[30px] mt-[10px]">
                                            <div className="gap-[10px]">
                                                <label
                                                    className={`block mb-2 text-sm font-medium text-gray-900`}
                                                >
                                                    Uygulamanız Yayınlanabilmesi için <a target="_blank" href="https://cloud.google.com/" className="text-[#7059ef]">Google Cloud Console</a> hesabınıza erişim yetkisi vermeniz gerekmektedir. Nasıl verileceğini öğrenmek için <a target="_blank" className="text-[#7059ef]">tıklayınız</a>.
                                                </label>

                                                <Checkbox isRequired className="" checked={storeData.isCheckedGoogleCloud} onChange={(e) => { updateStoreData("isCheckedGoogleCloud", e.target?.checked) }} color="primary" >
                                                    <span>
                                                        Google Cloud Console yetkisi verdim.
                                                    </span>
                                                </Checkbox>
                                            </div>
                                            <div className="gap-[10px]">
                                                <label
                                                    className={`block mb-2 text-sm font-medium text-gray-900`}
                                                >
                                                    Uygulamanız <a target="_blank" href="https://play.google.com/" className="text-[#7059ef]">Play Store</a> üzerinde yayınlanabilmesi için Play Store hesabınıza erişim yetkisi vermeniz gerekmektedir. Nasıl verileceğini öğrenmek için <a target="_blank" className="text-[#7059ef]">tıklayınız</a>.
                                                </label>

                                                <Checkbox isRequired className="" checked={storeData.isCheckedGooglePlay} onChange={(e) => { updateStoreData("isCheckedGooglePlay", e.target?.checked) }} color="primary" >
                                                    <span>
                                                        Play Store yetkisi verdim.
                                                    </span>
                                                </Checkbox>
                                            </div>

                                            <div className="gap-[10px]">
                                                <label
                                                    className={`block mb-2 text-sm font-medium text-gray-900`}
                                                >
                                                    Uygulamanız <a target="_blank" href="https://developer.apple.com/" className="text-[#7059ef]">App Store</a> üzerinde yayınlanabilmesi için Apple Developer hesabınıza erişim yetkisi vermeniz gerekmektedir. Nasıl verileceğini öğrenmek için <a target="_blank" className="text-[#7059ef]">tıklayınız</a>.
                                                </label>

                                                <Checkbox isRequired className="" checked={storeData.isCheckedAppleDeveloper} onChange={(e) => { updateStoreData("isCheckedAppleDeveloper", e.target?.checked) }} color="primary" >
                                                    <span>
                                                        Apple Developer yetkisi verdim.
                                                    </span>
                                                </Checkbox>
                                            </div>


                                        </div>

                                    </div>
                                </> :
                                <div className="text-sm pt-[10px] py-2 text-[#8A92A6] text-[15px] font-medium">Uygulama mobligo üzerinden yayınlanacaktır.</div>
                            }
                        </div>
                    </div>


                </div>



            </div>


            <button className="hidden" ref={storeFormButton} type="submit" ></button>
        </form>
    )
}

export default Store
